import { Injectable } from '@angular/core';
import { NydusNetworkApiDataService } from '@rd/core/services/nydus-network-api-data/nydus-network-api-data.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

interface SupportTicketsPostParams {
  supportTicket: {
    subject?: string;
    question: string;
    details: string;
    name: string;
    email: string;
  };
}

@Injectable({
  providedIn: 'root',
})
export class SupportTicketsApiService {
  constructor(private nydusNetworkApiDataService: NydusNetworkApiDataService) {}

  postSupportTickets(params: SupportTicketsPostParams): Observable<boolean> {
    return this.nydusNetworkApiDataService
      .post<void>('support_tickets', { ...params })
      .pipe(
        map(() => {
          return true;
        }),
      );
  }
}
